import { render } from "./CreationApprovisionement.vue?vue&type=template&id=6a0fd2c5&scoped=true"
import script from "./CreationApprovisionement.vue?vue&type=script&lang=js"
export * from "./CreationApprovisionement.vue?vue&type=script&lang=js"

import "./CreationApprovisionement.vue?vue&type=style&index=0&id=6a0fd2c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0fd2c5"]])

export default __exports__